/* Fullscreen menu — the reference's exact open/close choreography, ported
   from their GSAP timeline to WAAPI:
   open:  overlay fades in · the full-height IMAGE panel drops (-101% → 0) ·
          the two curtain panels follow, staggered (sauna flash, then snow,
          0.575s each) · links drop in masked from above (-140% → 0, 50ms
          stagger) · the small fades (close, brand, cart/join/instagram,
          image texts) come last.
   close: everything runs back up with the same stagger, then hidden.
   Plus the photo deck: hovering the link list wipes the top-left stage open
   and each link slides its photo in over the previous one (same mechanic as
   the footer). Desktop/fine-pointer only for the deck.
   Scroll lock, Escape, focus return; reduced motion = plain show/hide. */
(function () {
  var EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';
  var FULL = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';
  var TOP_EDGE = 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)';
  var BOTTOM_EDGE = 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)';

  var menu = document.querySelector('[data-menu]');
  if (!menu) return;

  var openBtn = document.querySelector('[data-menu-open]');
  var overlay = menu.querySelector('[data-menu-overlay]');
  var panelFull = menu.querySelector('[data-menu-panelfull]');
  var panels = [].slice.call(menu.querySelectorAll('[data-menu-panel]'));
  var links = [].slice.call(menu.querySelectorAll('.onni-menu_link'));
  var fades = [].slice.call(menu.querySelectorAll('[data-menu-fade]'));
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastFocused = null;
  var closeTimer = null;

  /* Real-time animations fast-forward across main-thread freezes: if the
     browser janks ~1s just after open() starts (seen in Arc, Jul 2026), the
     whole choreography lands on its end state having painted zero in-between
     frames — the menu "snaps" open. So the open/close animations run PAUSED
     and are advanced by our own clock, which steps at most MAX_STEP per
     painted frame (the Lenis-ticker idea): a freeze now briefly holds the
     choreography instead of skipping it. Paused + fill:'forwards' holds the
     end state exactly like the free-running version did. */
  var MAX_STEP = 90;
  var driven = [];
  var drivenRaf = 0;
  var drivenLast = 0;

  function tickDriven(now) {
    var dt = Math.min(now - drivenLast, MAX_STEP);
    drivenLast = now;
    driven = driven.filter(function (a) {
      if (a.playState !== 'paused') return false; // cancelled elsewhere
      var timing = a.effect.getTiming();
      var end = (timing.delay || 0) + timing.duration;
      var next = Math.min((a.currentTime || 0) + dt, end);
      a.currentTime = next;
      return next < end;
    });
    if (driven.length) drivenRaf = requestAnimationFrame(tickDriven);
    else drivenRaf = 0;
  }

  function drive(a) {
    a.pause();
    a.currentTime = 0;
    driven.push(a);
    if (!drivenRaf) {
      drivenLast = performance.now();
      drivenRaf = requestAnimationFrame(tickDriven);
    }
  }

  function slide(el, from, to, duration, delay) {
    drive(el.animate(
      [{ transform: 'translateY(' + from + ')' }, { transform: 'translateY(' + to + ')' }],
      { duration: duration, delay: delay || 0, easing: EASE, fill: 'forwards' }
    ));
  }

  function fade(el, from, to, duration, delay) {
    drive(el.animate(
      [{ opacity: from }, { opacity: to }],
      { duration: duration, delay: delay || 0, easing: EASE, fill: 'forwards' }
    ));
  }

  /* every open/close animation carries fill:'forwards' and stays alive on the
     element until cancelled — after an instant close (Barba navigation) a
     stale forwards-fill can win the first frame of the next open, showing the
     links already in place. Cancel the lot for a clean slate. */
  var animTargets = [overlay, panelFull].concat(panels, links, fades);
  function cancelMenuAnims() {
    animTargets.forEach(function (el) {
      if (el && el.getAnimations) {
        el.getAnimations().forEach(function (a) { a.cancel(); });
      }
    });
    // all driven animations are menu animations, so the list is stale now
    driven = [];
    if (drivenRaf) { cancelAnimationFrame(drivenRaf); drivenRaf = 0; }
  }

  function open() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    cancelMenuAnims(); // start from the CSS resting states, never a stale fill
    lastFocused = document.activeElement;
    menu.hidden = false;
    void menu.offsetWidth;
    menu.classList.add('is-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';

    if (reduceMotion) {
      overlay.style.opacity = '1';
      panelFull.style.transform = 'none';
      panels.forEach(function (p) { p.style.transform = 'none'; });
      links.forEach(function (l) { l.style.transform = 'none'; });
      fades.forEach(function (f) { f.style.opacity = '1'; });
    } else {
      fade(overlay, 0, 1, 600);
      slide(panelFull, '-101%', '0%', 800);
      panels.forEach(function (p, i) { slide(p, '-101%', '0%', 575, 120 + i * 100); });
      links.forEach(function (l, i) { slide(l, '-140%', '0%', 575, 200 + i * 50); });
      fades.forEach(function (f) { fade(f, 0, 1, 575, 430); });
    }

    var closeBtn = menu.querySelector('.onni-menu_close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    menu.classList.remove('is-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';

    if (reduceMotion) {
      menu.hidden = true;
    } else {
      fades.forEach(function (f) { fade(f, 1, 0, 350); });
      links.forEach(function (l) { slide(l, '0%', '-140%', 500, 40); });
      // DOM order like the reference: sauna (behind) first, snow last — no
      // accent flash on the way out
      panels.forEach(function (p, i) { slide(p, '0%', '-101%', 575, 80 + i * 110); });
      slide(panelFull, '0%', '-101%', 650, 220);
      fade(overlay, 1, 0, 500, 300);

      closeTimer = setTimeout(function () {
        if (!menu.classList.contains('is-open')) menu.hidden = true;
      }, 900);
    }

    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  if (openBtn) openBtn.addEventListener('click', open);
  menu.querySelectorAll('[data-menu-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  /* Barba navigation: the incoming page wipes over everything, so the menu
     snaps shut instantly — no exit animation racing the page transition.
     Cancel the running animations too: their forwards-fills would otherwise
     linger and can flash the links into place on the next open. */
  document.addEventListener('onni:page:out', function () {
    if (!menu.classList.contains('is-open')) return;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    cancelMenuAnims();
    menu.classList.remove('is-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    menu.hidden = true;
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
  });

  /* ---------- photo deck on link hover (footer mechanic) ---------- */
  var stage = menu.querySelector('[data-menu-stage]');
  var wrap = menu.querySelector('[data-menu-triggers]');
  if (!stage || !wrap) return;

  var deckMedia = window.matchMedia('(min-width: 992px) and (pointer: fine)');

  function deckActive() {
    return deckMedia.matches && !reduceMotion;
  }

  wrap.addEventListener('mouseenter', function () {
    if (!deckActive()) return;
    stage.animate(
      [{ clipPath: TOP_EDGE }, { clipPath: FULL }],
      { duration: 600, easing: EASE, fill: 'forwards' }
    );
  });

  wrap.addEventListener('mouseleave', function () {
    if (!deckActive()) return;
    stage.animate(
      [{ clipPath: FULL }, { clipPath: BOTTOM_EDGE }],
      { duration: 600, easing: EASE, fill: 'forwards' }
    );
  });

  wrap.querySelectorAll('[data-menu-trigger]').forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      if (!deckActive()) return;

      var layer = document.createElement('div');
      var media_el;
      if (link.dataset.img) {
        media_el = document.createElement('img');
        media_el.src = link.dataset.img;
        media_el.alt = '';
      } else {
        media_el = document.createElement('span');
        media_el.className = 'onni-menu_stage-ph onni-menu_stage-ph--' + (link.dataset.ph || '1');
      }
      layer.appendChild(media_el);
      stage.appendChild(layer);

      layer.animate(
        [{ transform: 'translateY(-100%)' }, { transform: 'translateY(0)' }],
        { duration: 600, easing: EASE, fill: 'forwards' }
      );
      media_el.animate(
        [{ transform: 'translateY(90%)' }, { transform: 'translateY(0)' }],
        { duration: 600, easing: EASE, fill: 'forwards' }
      );

      while (stage.children.length > 12) {
        stage.removeChild(stage.firstChild);
      }
    });
  });
})();
